import { statusBoardService } from "../pages/StatusBoard/StatusBoard.service";
import { utilService } from "./utilService";
import { Subject } from "rxjs";
import { apiService } from ".";
import { apiServiceConstants } from "../constants";
import _ from "lodash";

let reminderData: any = [];
let showReminderAlert = new Subject<any>();
let reminderListUpdated = new Subject<any>();
let timeOutArray: any = [];
let formattedTimeDifference: any = 0;

const updateTime = (time: any) => {
  const currentTime = time.split(":");
  return currentTime[0] + ":" + currentTime[1];
};

const formatTimeInSeconds = (time: any) => {
  var array = time?.split(":");
  var timeInSeconds =
    parseInt(array[0], 10) * 60 * 60 + parseInt(array[1], 10) * 60 + 0;

  return timeInSeconds;
};

const setUpdatedReminderList = () => {
  if (timeOutArray.length) {
    formattedTimeDifference = 0;
    timeOutArray.forEach((element: any) => {
      clearTimeout(element.timeOutID);
    });
    timeOutArray = [];
  }
  const unitDetails = statusBoardService.statusBoardData
    ? statusBoardService.statusBoardData
    : [];
  if (
    unitDetails &&
    unitDetails.length &&
    statusBoardService.isBedSwappedOrTransferredId
  ) {
    const selectedBed = unitDetails[0].bedList.filter(
      (item: any) => item.id === statusBoardService.isBedSwappedOrTransferredId
    );
    if (!utilService.isEmpty(selectedBed)) {
      const selectedBedName = selectedBed[0].frozen_columns.room.value;
      if (reminderData.length) {
        const fromBed = unitDetails[0].bedList.filter(
          (item: any) =>
            item.id === statusBoardService.isBedSwappedOrTransferredFromId
        );
        const fromBedName = fromBed[0].frozen_columns.room.value;
        swapTransferBed(fromBedName, selectedBedName);
      }
    }
  }
};

const clearTimeOutOfDeletedCard = (id: any) => {
  const removedTimeOutObject = _.find(timeOutArray, { reminderId: id });
  if (removedTimeOutObject) {
    clearTimeout(removedTimeOutObject.timeOutID);
  }
  utilService.removeObject(timeOutArray, "reminderId", id);
};

const swapTransferBed = (fromBedName: any, selectedBedName: any) => {
  reminderData.forEach((data: any, arrayIndex: number) => {
    if (data.bedName === fromBedName) {
      data.bedName = selectedBedName;
    }
  });
  statusBoardService.isBedSwappedOrTransferredId = "";
  statusBoardService.isBedSwappedOrTransferredFromId = "";
  getReminderAlerts(reminderData);
};

// To show the reminder alerts
const getReminderAlerts = (reminderList: any) => {
  if (reminderList && reminderList.length > 0) {
    if (timeOutArray.length) {
      formattedTimeDifference = 0;
      timeOutArray.forEach((element: any) => {
        clearTimeout(element.timeOutID);
      });
      timeOutArray = [];
    }
    reminderData = reminderList;
    const getTime = new Date().toTimeString();
    const formatTime = getTime.slice(0, 8);
    const currentTime = formatTime.split(":");
    const getTimeInputData = currentTime[0] + ":" + currentTime[1];
    reminderList.forEach((element: any, index: number) => {
      if (
        utilService.findObjectIndex(
          statusBoardService?.checkedReminders,
          "id",
          element.id
        ) === -1
      ) {
        const reminderTime: any = updateTime(element.time);
        const reminder = formatTimeInSeconds(reminderTime);
        const currentTime = formatTimeInSeconds(getTimeInputData);
        const timeDifference = reminder - currentTime;
        formattedTimeDifference =
          timeDifference < 0 ? 86400 - timeDifference * -1 : timeDifference; // 86400 - 24 hrs in secs
        showReminderAlertWithTimeDifference(formattedTimeDifference, element);
      }
    });
  } else {
    reminderData = [];
  }
};
const reminderListUpdate = (list: any) => {
  reminderListUpdated.next(list);
};

const getRemindersFromServer = async (page: number): Promise<any> => {
  const params: any = { page: page };
  const respApiResult = await apiService
    .apiCall(
      `sboard/unit/my-statusboard/reminders/?reg_code=${utilService.getNetwork()}`,
      params,
      apiServiceConstants.GET,
      utilService.getDeviceType()
    )
    .then((res) => {
      const ReminderListResp = res as any;
      var ReminderInformationResponse: any;
      if (ReminderListResp.result) {
        ReminderInformationResponse = SetReminderList(ReminderListResp.result);
      }
      const result: any = {
        isSuccess: true,
        result: ReminderInformationResponse,
        status: ReminderListResp.status,
        message: ReminderListResp.message,
      };
      parseReminderResult(result);
      return result;
    })
    .catch((err) => {
      const result: any = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });

  return respApiResult;
};

const showReminderAlertWithTimeDifference = (
  formattedTimeDifference: any,
  element: any
) => {
  let timeOut = setTimeout(() => {
    if (formattedTimeDifference !== 0) {
      showReminderAlert.next(element);
      statusBoardService.checkedReminders.push(element);
    }
  }, formattedTimeDifference * 1000);

  const timeOutObject = {
    timeOutID: timeOut,
    reminderId: element.id,
  };
  const isTimeOutObjectAlreadyAdded = _.find(timeOutArray, {
    reminderId: element.id,
  });
  if (!isTimeOutObjectAlreadyAdded) {
    timeOutArray.push(timeOutObject);
  }
};

const parseReminderResult = (reminderResult: any) => {
  var reminderList: any = [];
  if (!_.isEmpty(reminderResult.result)) {
    reminderResult.result.forEach((element: any) => {
      element.sboard.patient.forEach((patient: any) => {
        reminderList = [...reminderList, ...patient.reminders];
      });
    });
    getReminderAlerts(reminderList);
  }
};

const SetReminderList = (reminderResult: any) => {
  const result = mapResult(reminderResult);
  return result;
};

const mapResult = (responseResult: any) => {
  let remResult: any = [];
  responseResult.map((items: any) => {
    var sboard = {
      sboard: mapSboard(items.sboard),
    };
    remResult.push(sboard);
  });
  return remResult;
};

const mapSboard = (sboardValue: any) => {
  let remResult: any = {
    index: sboardValue.index,
    patient: mapPatients(sboardValue.patient),
  };
  return remResult;
};

const mapPatients = (patients: any) => {
  let patientsArray: any = [];
  patients.map((items: any) => {
    var patient = {
      reminders: mapReminders(items.reminders[0]),
    };
    patientsArray.push(patient);
  });
  return patientsArray;
};

const mapReminders = (reminders: any) => {
  let remindersArray: any = [];
  reminders.map((item: any) => {
    var rem = {
      bedName: item.bed_name,
      id: item.id,
      time: item.time,
      title: item.title,
    };
    remindersArray.push(rem);
  });
  return remindersArray;
};

export const ReminderAlertService = {
  getReminderAlerts,
  getRemindersFromServer,
  showReminderAlert,
  reminderData,
  reminderListUpdate,
  reminderListUpdated,
  parseReminderResult,
  setUpdatedReminderList,
  clearTimeOutOfDeletedCard,
};
